// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebaseConfig:{
    apiKey: "AIzaSyA0N-FXjP2WnmjTaE_Hy3cMNaPyeJm6bxc",
    authDomain: "camedulearning.firebaseapp.com",
    databaseURL: "https://camedulearning.firebaseio.com",
    projectId: "camedulearning",
    storageBucket: "camedulearning.appspot.com",
    messagingSenderId: "610661271630",
    appId: "1:610661271630:web:68ff3d77327480f1499b1f",
    measurementId: "G-XXD2DPCD3Z"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
